
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 36 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.164 32h-4.652c-.593 0-1.075-.506-1.075-1.131s.481-1.131 1.075-1.131h4.652c.593 0 1.075.506 1.075 1.131S35.758 32 35.164 32z"}}),_c('path',{attrs:{"d":"M26.132 32H1.117c-.593 0-1.074-.506-1.074-1.131s.481-1.131 1.074-1.131h25.015c.593 0 1.075.506 1.075 1.131S26.726 32 26.132 32z"}}),_c('path',{attrs:{"d":"M31.015 3.241h-6.5-4.855-.509-.86-3.397c-.487 0-.883.277-.883.619v2.03c0 .346.396.622.883.622H31.015c.487 0 .882-.276.882-.622V3.86c0-.342-.395-.619-.882-.619z"}}),_c('path',{attrs:{"d":"M21.827 12.768h-6.5-4.855-.509-.86-3.397c-.488 0-.883.277-.883.619v2.029c0 .346.395.623.883.623H21.827c.487 0 .882-.277.882-.623v-2.029c0-.343-.395-.619-.882-.619z"}}),_c('path',{attrs:{"d":"M33.182 6.226V13.862c0 .511-.384.924-.854.924h-2.179l-.668.003h-3.446V12.49c0-1.633-1.298-2.964-2.894-2.964h-2.18-4.704-.929-2.6v-.159-.727-1.725-.69-3.261c0-.509.385-.923.854-.923h18.747c.47 0 .854.414.854.923v3.261zm-9.188 9.528v7.636c0 .511-.384.925-.854.925h-2.18l-.667.002h-4.966-4.855-.51-.859H7.24l-.669-.002H4.393c-.47 0-.854-.414-.854-.925v-4.492-.729-1.725-.69-3.262c0-.508.385-.922.854-.922H23.139c.47 0 .854.414.854.922v3.262zM32.328 0h-2.179-4.703-.93-4.855-.509-.86-.929-1.602-2.179c-1.596 0-2.896 1.33-2.896 2.965v6.562h-.213-.51-.859-.93-1.602-2.178c-1.599 0-2.896 1.33-2.896 2.964v10.898c0 1.636 1.297 2.966 2.896 2.966h2.178l.663.004H20.3l.661-.004h2.18c1.596 0 2.894-1.33 2.894-2.966v-4.492-.729-1.337h3.452l.662-.003h2.179c1.596 0 2.896-1.329 2.896-2.966V9.368v-.727-1.725-.69-3.261c0-1.636-1.3-2.965-2.896-2.965z"}})])
          )
        }
      }
    